export default __webpack_public_path__ + "static/media/basic-pin-small-5.42c12183.png";